import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";

import { selectBadge } from "@faire/retailer/components/ProductBadge/badgeUtils";
import { handleShowroomProductBadgeViewed } from "@faire/retailer/components/Showroom/ShowroomBadgeUtils";
import { useProductTileClickImpressionContext } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressionContext";

export const useRecordProductBadgeViewEvent = (
  productTile: ILeanProductTile | undefined,
  recordImpressions = false
) => {
  const { requestId, badgeEventTokens } =
    useProductTileClickImpressionContext();
  return useEffectEvent(() => {
    const { product, badge_list } = productTile ?? ILeanProductTile.build({});
    if (
      !recordImpressions ||
      !product?.token ||
      badgeEventTokens.has(product.token)
    ) {
      return;
    }
    const topLeftTileBadge = selectBadge(badge_list?.badges ?? [], "TOP");
    handleShowroomProductBadgeViewed(
      product.token,
      requestId,
      topLeftTileBadge
    );
    badgeEventTokens.add(product.token);
  });
};
